// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictionConfigInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');
  var classnames = require('classnames');
  var observer = require('mobx-react').observer;
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var Button = require('share/components/controls/Izenda.Button');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
  var ValidatableSecuredInput = Validator()(require('share/components/controls/Izenda.SecuredInput'));
  var Numeric = Validator()(require('share/components/controls/Izenda.NumericInput'));
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var REQUIRE_CONSTRAINTS = require('logic/data/Izenda.EmailConstants').REQUIRE_CONSTRAINTS;
  const { assign } = require('lodash/fp');

  var PredictionConfigInput = function(props) {
    var type = props.type;
    var { store } = this.props;
    const model = this.props.store.model;
    var clazzName = classnames( 'customeHeight',{ 'validation required': props.isRequired });
    const notifyChange = EventUtils.notifyChange;
    var gridClass= {
      display: 'flex'
    };
    var label= this.props.localization.getText('NLQ_CONFIGURATION_SERVER_TEST');
    var placeholderLabels ={
       serverInput : 'Machine Learning Server IP Address',
       DBInput: 'Enter Database Connection String',
    }
    var displayNone = {
      display: "none"
    };
    var displayBlock = {
      display :"block"
    }

    return (
      <div>
          <GridLayout.Row>
            <GridLayout.Col cols={3}>
              <label className={clazzName}>
              {(model.dbConnectionShow) ? this.props.localization.getText('MACHINE_LEARNING_SETTINGS_LABEL_PREDICTION_SERVICE') : this.props.localization.getText('NLQ_SETTINGS_LABEL_PREDICTION_SERVICE')}

              </label>
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
                <div style={gridClass} className="col-md-12">
                      <div className="col-md-10">
                          <Input
                            className="form-control"
                            value={model.mlServerIp}
                            onChange={notifyChange(
                            model.changePredictionInput.bind(model),
                              EventUtils.INPUT
                            )}
                            placeholder={placeholderLabels.serverInput}
                          />
                        <div style={ (model.predictionServerSuccess) ? displayBlock : displayNone} className="u-posAbsolute success-color u-iconAfterInput">
                            <span className="icon-ok success-color" />
                        </div>
                      </div>
                    {/* <span className="icon-cancel" /> */}
                      <div className="col-md-2">
                        <Button
                          label={label}
                          className="btn-setting-default set-margin-btn "
                          onClick={this.props.onclickmlserver}
                        />
                      </div>
                </div>
            </GridLayout.Col>
          </GridLayout.Row>         
     </div>
    );


    function renderControl() {
      var InputControl = Input;

      if (props.isRequired) {
        InputControl = ValidateInput;
      }


        return (
          <div style={gridClass}>
              <Input
                className="form-control"
                value={props.value}
                onChange={handleChange}
                field={props.dataKey}
                validations={REQUIRE_CONSTRAINTS}
                placeholder={props.placeholder}
                shouldFocus
              />
              <Button
                label={label}
              />

          </div>
        );
    }

    function handleChange(value) {
      props.onChange(props.dataKey, value);
    }
  };

  module.exports = observer(PredictionConfigInput);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/MachineLearning/Izenda.PredictionConfigInput.jsx